import { ChangeEvent, useContext, useEffect, useState } from "react";

import { Radio, RadioGroup } from "@salesforce/design-system-react";

import { Input, Toggle } from "@vimeo/iris/components";
import { Text } from "@vimeo/iris/typography";

import EmbedInEmailContext from "../../contexts/embedInEmailContext";

import "./configureasset.scoped.scss";

type LinkDestination = "vimeo.com" | "custom" | "noLink";

interface Props {
    defaultVideoLink: string;
}

export function ConfigureAsset(props: Props) {
    const [embedInEmailContextState, setEmbedInEmailContextState] =
        useContext(EmbedInEmailContext);
    const [showPlayButton, setShowPlayButton] = useState(true);
    const [linkDestination, setLinkDestination] =
        useState<LinkDestination>("vimeo.com");

    useEffect(() => {
        setEmbedInEmailContextState({
            ...embedInEmailContextState,
            link: props.defaultVideoLink,
            createAssetWithPlayButton: showPlayButton,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function toggleShowPlayButton(checked: boolean) {
        setShowPlayButton(checked);
        setEmbedInEmailContextState({
            ...embedInEmailContextState,
            createAssetWithPlayButton: checked,
        });
    }

    return (
        <div className="slds-grid slds-grid_vertical">
            <div className="slds-col_padded slds-m-bottom_small">
                <img
                    src={
                        !showPlayButton
                            ? embedInEmailContextState.imgUrl
                            : embedInEmailContextState.imgUrlWithPlayButton
                    }
                    style={{
                        marginLeft: embedInEmailContextState.isPortraitImage
                            ? "30%"
                            : 0,
                        marginRight: embedInEmailContextState.isPortraitImage
                            ? "30%"
                            : 0,
                        maxWidth: embedInEmailContextState.isPortraitImage
                            ? "40%"
                            : "100%",
                    }}
                    alt={embedInEmailContextState.name}
                />
            </div>
            <div className="slds-col_padded slds-m-bottom_small">
                <Toggle
                    id="checkbox-toggle-example"
                    checked={showPlayButton}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        toggleShowPlayButton(event.target.checked);
                    }}
                    label="Show play button"
                />
            </div>
            <div className="slds-col_padded slds-m-bottom_small">
                <Text>Link</Text>
                <RadioGroup
                    onChange={(event: any) => {
                        const newLinkDestination = event.target
                            .value as LinkDestination;
                        setLinkDestination(newLinkDestination);
                        // Any time the user changes the link destination,
                        // set the link to either none or the default video
                        // link based on the destination type.
                        if (newLinkDestination === "noLink") {
                            setEmbedInEmailContextState({
                                ...embedInEmailContextState,
                                link: "none",
                            });
                        } else {
                            setEmbedInEmailContextState({
                                ...embedInEmailContextState,
                                link: props.defaultVideoLink,
                            });
                        }
                    }}
                >
                    <Radio
                        key="videopage"
                        id="videopage"
                        labels={{
                            label: (
                                <span style={{ fontSize: "14px" }}>
                                    Video page (vimeo.com)
                                </span>
                            ),
                        }}
                        value="vimeo.com"
                        checked={linkDestination === "vimeo.com"}
                    />
                    <Radio
                        key="custom"
                        id="custom"
                        labels={{
                            label: (
                                <span style={{ fontSize: "14px" }}>
                                    Custom destination
                                </span>
                            ),
                        }}
                        value="custom"
                        checked={linkDestination === "custom"}
                    />
                    <Radio
                        key="noLink"
                        id="noLink"
                        labels={{
                            label: (
                                <span style={{ fontSize: "14px" }}>
                                    No link
                                </span>
                            ),
                        }}
                        value="noLink"
                        checked={linkDestination === "noLink"}
                    />
                </RadioGroup>
            </div>
            <div className="slds-col_padded slds-m-bottom_small">
                <div className="slds-has-divider"></div>
            </div>
            <div className="slds-col_padded slds-m-bottom_small">
                <Input
                    id="disabled-input-id"
                    disabled={linkDestination !== "custom"}
                    type="url"
                    value={embedInEmailContextState.link}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        setEmbedInEmailContextState({
                            ...embedInEmailContextState,
                            link: event.target.value,
                        });
                    }}
                />
            </div>
        </div>
    );
}
